// extracted by mini-css-extract-plugin
export default {"frAttachment":"style_frAttachment__VQoDa","fileData":"style_fileData__hOf+o","iconButton":"style_iconButton__-61Kt"};